
import { defineComponent } from 'vue';
import { formatTime } from '@toy/utils';
import { useList } from '@/hooks/use-list';
import { getAlarmMessageList } from '@/api/message-center';
import { BOUND_TYPE_LIST } from '@/constant/message-center';
import type { IBoundSendRecordPageReq, IBoundSendRecordPageListItem } from '@/api/message-center/type.d';
import { UserItem } from '@/api/auth-manage/user/type.d';
import { fuzzyQueryUser } from '@/api/auth-manage/user/index';
import { useFuzzy } from '@/hooks/use-fuzzy';
// import usePermissionConfig from './use-permission-config';

export default defineComponent({
  components: {

  },
  setup() {
    const {
      params,
      tableTotal,
      tableData,
      tableLoading,
      handleSearch,
      handleReset,
      handleSizeChange,
      handleCurrentChange,
    } = useList<IBoundSendRecordPageListItem, IBoundSendRecordPageReq>({
      request: {
        api: getAlarmMessageList,
        params: {
          boundType: '',
          alertTarget: '',
          boundUserId: '',
          createdTime: [],
          pageNum: 1,
          pageSize: 20,
        },
        handleParams(paramsObj) {
          if (paramsObj.createdTime?.length === 2) {
            [paramsObj.createdTimeBegin, paramsObj.createdTimeEnd] = [
              `${formatTime(paramsObj.createdTime[0], 'YYYY-MM-DD')} 00:00:00`,
              `${formatTime(paramsObj.createdTime[1], 'YYYY-MM-DD')} 23:59:59`,
            ];
          }
          delete paramsObj.createdTime;
          return paramsObj;
        },
      },
    });

    const {
      fuzzyLoading,
      fuzzyResponse,
      fuzzyRemoteMethod,
    } = useFuzzy<any, UserItem[]>({
      params: { keyword: '' },
      keywordKey: 'keyword',
      API: fuzzyQueryUser,
      beforeRequest(param, query) {
        return query;
      },
      beforeResponse(res) {
        return res.data?.map((user: UserItem) => {
          const { name: label, userId: value } = user;
          return { ...user, label, value };
        });
      },
    });

    const init = () => {
      handleSearch();
    };

    init();

    // const permissionConfig = usePermissionConfig();

    return {
      params,
      tableTotal,
      tableData,
      tableLoading,
      handleSearch,
      handleReset,
      handleSizeChange,
      handleCurrentChange,
      // permissionConfig,
      fuzzyLoading,
      fuzzyResponse,
      fuzzyRemoteMethod,
      BOUND_TYPE_LIST,
    };
  },
});
